import styled from 'styled-components';

// The placement panel reads as three numbered steps - shift, addresses, days - for one passenger and for
// several alike (customer request, 2026-11-02). The badge sits inside each step's own title element.
export const StepNumber = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    margin-inline-end: 8px;
    border-radius: 50%;
    background: #1976d2; // white on it is 4.6:1
    color: white;
    font-size: 12px;
    font-weight: 700;
    flex: none;
`;

export const StepTitle = styled.h3`
    display: flex;
    align-items: center;
    margin: 12px 0 0;
    font-size: 15px;
    font-weight: 700;
`;
